<template>
    <v-container grid-list-md text-xs-center>
        <h2 class="subheading grey--text">{{$t('entradas_salidas')}}</h2>
        <!--    Diálogo Configurar IP   -->
        <v-dialog v-model="dialogIP" persistent width="400">
            <v-card class="justify-center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Cambiar IP</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogIP = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-text-field
                        v-model="ip"
                        outline
                        label="IP"
                        placeholder="192.168.1.45"
                    >
                    </v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialogIP = false, changeDirIP()"
                    >
                        {{$t('modificar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Errores   -->
        <v-dialog v-model="dialog_errores"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
                    <h3 class="text-xs-center">{{errores_guard}}</h3>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            v-if="band_gafete"
                            color="primary"
                            x-small
                            :loading="loading_gafete"
                            @click="download_gafete"
                    >{{$t('print_name_tag')}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = '', activar_camara = true, band_gafete = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialog_inicio" persistent max-width="400px">
            <v-form @submit.prevent="set_caseta()">
                <v-card class="justify-center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('selecciona_caseta')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-autocomplete
                                v-model="caseta"
                                name="caseta"
                                :items="casetas"
                                item-text="nombre"
                                item-value="id"
                                :label="$t('Casetas')"
                        ></v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                type="submit"
                        >{{ $t('aceptar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog v-model="dialog" persistent scrollable max-width="400px">
            <v-card v-if="empleado" color="blue-grey lighten-4" class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Informacion del Empleado</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-flex class="text-xs-center" xs12>
                        <v-layout row wrap justify-center align-center>
                            <v-flex xs12>
                                <v-img
                                        :src="info_invitation.avatar"
                                ></v-img>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Empleado')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.fullname}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-layout align-center justify-center row wrap>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                    large
                                    color="error"
                                    @click="dialog = false, activar_camara = true"
                            >{{ $t('cerrar')}}
                            </v-btn>
                            <v-btn
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(info_invitation.rfid), dialog = false, qr_code='', entrada = false, salida = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
            <v-card v-if="entrada" :color="info_invitation.authorized ? 'blue-grey lighten-4' : 'yellow lighten-2'" class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_invitation).length > 0">
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_invitado')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.guest_Avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Visitante')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestFirstName}}
                                                {{ info_invitation.guestLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestCellPhone}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.guestNameCompany !== null">
                                        <th>
                                            <h2>
                                                {{$t('Empresa')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestNameCompany}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.secEqu.length > 0">
                                        <th>
                                            <h2>
                                                {{$t('equipo_seguridad')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h3>

                                                <div v-for="(equipo, index) in info_invitation.secEqu" v-bind:key="equipo.index">
                                                    <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>
                                                </div>
                                            </h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Asunto')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.asunto}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('dias_validos')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2 v-if="info_invitation.diary.includes('0') === true">
                                                {{ $t('Lunes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('1') === true">
                                                {{ $t('Martes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('2') === true">
                                                {{ $t('Miercoles') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('3') === true">
                                                {{ $t('Jueves') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('4') === true">
                                                {{ $t('Viernes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('5') === true">
                                                {{ $t('Sabado') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('6') === true">
                                                {{ $t('Domingo') }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('fecha_expiracion')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.expiration}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-text-field
                                                v-if="info_invitation.automovil"
                                                v-model="datos_coche"
                                                prepend-icon="directions_car"
                                                name="datos_coche"
                                                :label="$t('datos_coche')"
                                                :error-messages="errores.datos_coche"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-btn
                                                v-if="info_invitation.automovil"
                                                color="primary"
                                                x-small
                                        >{{$t('guardar')}}
                                        </v-btn>
                                        <!--                                                            <v-btn-->
                                        <!--                                                                    color="primary"-->
                                        <!--                                                                    x-small-->
                                        <!--                                                                    :loading="loading_gafete"-->
                                        <!--                                                                    @click="download_gafete"-->
                                        <!--                                                            >Imprimir Gafete-->
                                        <!--                                                            </v-btn>-->
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_anfitrion')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.host_avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Anfitrion')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.hostFirstName}}
                                                {{ info_invitation.hostLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.host_celular}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-layout align-center justify-center row wrap>
                        <v-flex v-if="!info_invitation.authorized" xs12 class="text-xs-center">
                            <h3>{{$t('attemps')}} : {{info_invitation.count}}/2</h3>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                    large
                                    color="error"
                                    @click="dialog = false, activar_camara = true"
                            >{{ $t('cerrar')}}
                            </v-btn>
                            <v-btn
                                    v-if="info_invitation.authorized"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(info_invitation.id), dialog = false, qr_code='', entrada = false, salida = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0"
                                    large
                                    color="primary"
                                    :loading="loading"
                                    @click="notificar_anfitrion_acceso()"
                            >
                                Notificar al anfitrión <br> autorizar acceso
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count === 0"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(info_invitation.id), dialog = false, qr_code='', entrada = false, salida = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0"
                                    large
                                    :loading="loadingCountIn"
                                    color="primary"
                                    @click="updateCountEntrada()"
                            >
                                <v-icon>refresh</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
            <v-card v-if="salida" :color="data_access[0].pase_salida ? 'blue-grey lighten-4' : 'red lighten-2'" class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('form_salida')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_invitation).length > 0">
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_invitado')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.guest_Avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Visitante')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestFirstName}}
                                                {{ info_invitation.guestLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestCellPhone}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.guestNameCompany !== null">
                                        <th>
                                            <h2>
                                                {{$t('Empresa')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestNameCompany}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.secEqu.length > 0">
                                        <th>
                                            <h2>
                                                {{$t('equipo_seguridad')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h3>
                                                <div v-for="(equipo, index) in info_invitation.secEqu" v-bind:key="equipo.index">
                                                    <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>
                                                </div>
                                            </h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Asunto')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.asunto}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('dias_validos')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2 v-if="info_invitation.diary.includes('0') === true">
                                                {{ $t('Lunes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('1') === true">
                                                {{ $t('Martes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('2') === true">
                                                {{ $t('Miercoles') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('3') === true">
                                                {{ $t('Jueves') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('4') === true">
                                                {{ $t('Viernes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('5') === true">
                                                {{ $t('Sabado') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('6') === true">
                                                {{ $t('Domingo') }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('fecha_expiracion')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.expiration}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-text-field
                                        v-if="info_invitation.automovil"
                                        v-model="datos_coche"
                                        prepend-icon="directions_car"
                                        name="datos_coche"
                                        :label="$t('datos_coche')"
                                        :error-messages="errores.datos_coche"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-btn
                                        v-if="info_invitation.automovil"
                                        color="primary"
                                        x-small
                                >{{$t('guardar')}}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <br>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_anfitrion')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.host_avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas" style="width:100%">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Anfitrion')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.hostFirstName}}
                                                {{ info_invitation.hostLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>{{$t('celular')}}:</h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.host_celular}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>{{$t('Area')}}:</h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('Información de Acceso')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12>
                                <table :color="data_access[0].pase_salida ? 'success' : 'error'"  id="datas" style="width:100%">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Fecha y hora de acceso')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].fecha_hora_acceso}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Fecha y hora de salida')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].fecha_hora_salida ? data_access[0].fecha_hora_salida : "Pendiente" }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Estado')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{data_access[0].estado == '1' ? "Adentro" : "Afuera"}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Pase de salida')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].pase_salida ? "Firmado" : "No Firmado"}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-layout align-center justify-center row wrap>
                        <v-flex v-if="!data_access[0].pase_salida" xs12 class="text-xs-center">
                            <h3>{{$t('attemps')}} : {{data_access[0].count}}/2</h3>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                    large
                                    color="error"
                                    @click="dialog = false, activar_camara = true"
                            >{{ $t('cerrar')}}
                            </v-btn>
                            <v-btn
                                    v-if="data_access[0].pase_salida"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="update_acceso(data_access[0].id), activar_camara = true"
                            >{{$t('registrar_salida')}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0"
                                    large
                                    color="primary"
                                    :loading="loading"
                                    @click="notificar_anfitrion_firmar()"
                            >
                                Notificar al anfitrión <br> firmar pase de salida
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count === 0"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="update_acceso(data_access[0].id), activar_camara = true"
                            >{{$t('registrar_salida')}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0"
                                    large
                                    :loading="loadingCount"
                                    color="primary"
                                    @click="updateCount()"
                            >
                                <v-icon>refresh</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
       <v-container grid-list-md text-xs-center>
       <v-layout row wrap>
         <v-flex xs3>
           <v-card class="mx-auto elevation-7">
             <v-toolbar class="mb-1" dark color="primary">
               <!--                <v-btn-->
               <!--                        color="blue"-->
               <!--                        dark-->
               <!--                        medium-->
               <!--                        absolute-->
               <!--                        bottom-->
               <!--                        left-->
               <!--                        fab-->
               <!--                        @click="dialogIP = !dialogIP"-->
               <!--                >-->
               <!--                    <v-icon>settings</v-icon>-->
               <!--                </v-btn>-->
               <v-toolbar-title>
                 {{$t('entradas_salidas')}}
               </v-toolbar-title>
             </v-toolbar>
             <!--            <v-toolbar class="mb-1" dark color="primary">-->
             <!--                <v-toolbar-title>-->
             <!--                    {{$t('entradas_salidas')}}-->
             <!--                </v-toolbar-title>-->
             <!--                <v-spacer></v-spacer>-->
             <!--            </v-toolbar>-->
             <v-card-text class="text-xs-center">
               <!--                <h3>{{$t('mensaje_acercar_QR')}}</h3>-->
               <!--                <v-spacer></v-spacer>-->
               <v-form>
                 <!--                    <v-layout class="justify-center" row wrap>-->
                 <!--                        <v-flex xs8>-->
                 <!--                            <qrcode-stream v-if="activar_camara" @decode="onDecode" @init="onInit" />-->
                 <!--                            <p class="error">{{ error }}</p>-->
                 <!--                        </v-flex>-->
                 <!--                    </v-layout>-->
                 <v-layout class="justify-center">
                   <v-form @submit.prevent="get_invitation_manual()">
                     <v-flex xs12>
                       <v-text-field
                           v-model="a_qr_code"
                           autofocus
                           prepend-icon="select_all"
                           name="a_qr_code"
                           :label="$t('qr_code')"
                           autocomplete="off"
                           :placeholder="$t('msg_qr_code')"
                       >
                       </v-text-field>
                       <v-btn
                           :loading="loading"
                           color="primary"
                           large
                           type="submit">{{$t('enviar')}}
                       </v-btn>
                     </v-flex>
                   </v-form>
                 </v-layout>
               </v-form>
             </v-card-text>
             <v-card-actions>
                               <v-card-text>
                    <v-flex class="text-xs-center" xs12>
                        <v-layout row wrap justify-center align-center>
                            <v-flex xs12>
                                <v-img
                                        :src="info_invitation.avatar"
                                ></v-img>
<!--                                <table id="datas">-->
<!--                                    <tr>-->
<!--                                        <th>-->
<!--                                            <h2>-->
<!--                                                {{$t('Empleado')}}:-->
<!--                                            </h2>-->
<!--                                        </th>-->
<!--                                        <td>-->
                                            <h2>
                                                {{ info_invitation.fullname}}
                                            </h2>
<!--                                        </td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <th>-->
<!--                                            <h2>-->
<!--                                                {{$t('Area')}}:-->
<!--                                            </h2>-->
<!--                                        </th>-->
<!--                                        <td>-->
<!--                                            <h2>-->
<!--                                                {{ info_invitation.areaName}}-->
<!--                                            </h2>-->
<!--                                        </td>-->
<!--                                    </tr>-->
<!--                                </table>-->
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
             </v-card-actions>
           </v-card>
         </v-flex>
         <v-flex xs9>
           <v-card color="secondary">
             <v-data-table
                 :headers="headers4"
                 :loading="loading_data_accesos_without_code"
                 :items="accesos_without_code"
                 :rows-per-page-text="$t('filas_por_pagina')"
                 :rows-per-page-items="[
                                        {text: '20', value: 20},
                                    ]"
                 class="elevation-1"
                 :no-data-text="$t('no_registros_accesos')"
             >
               <template v-slot:items="props">
                 <!--                                    <td class="justify-center layout px-0">-->
                 <!--                                        <v-icon-->
                 <!--                                                medium-->
                 <!--                                                class="mr-2"-->
                 <!--                                                @click="fill_fields(props.item),-->
                 <!--                                                dialog_accesos_without_code = true"-->
                 <!--                                        >-->
                 <!--                                            search-->
                 <!--                                        </v-icon>-->
                 <!--                                    </td>-->
                 <td>{{ props.item.full_name }}</td>
                 <td>{{ props.item.f_acceso }}</td>
                 <td>{{ props.item.id_caseta_in }}</td>
                 <td>{{ props.item.f_salida }}</td>
                 <td>{{ props.item.id_caseta_out }}</td>
               </template>
               <template v-slot:pageText="props">
                 {{props.rowsPerPage}}
                 {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
               </template>
             </v-data-table>
           </v-card>
         </v-flex>
       </v-layout>
       </v-container>
    </v-container>
</template>

<script>
    import { QrcodeStream } from 'vue-qrcode-reader'
    import store from '@/store'
    import { mapState, mapGetters } from 'vuex'
    import jsPDF from 'jspdf'

    export default {
        name: "check_in_out_employees",
        components: {
            QrcodeStream
        },
        data () {
            return {
                qr_code: '',
                error: '',
                info_invitation: [],
                dialog: false,
                valido: false,
                id_vigilante: 0,
                salida: false,
                entrada: false,
                empleado: false,
                estado: '',
                motivo_no_firma: '',
                comentarios_VE: '',
                errores: [],
                datos_coche: '',
                equipo_por_invitacion: [],
                data_access: [],
                dialog_inicio: false,
                casetas: [],
                caseta: 0,
                activar_camara: true,
                loading_gafete: false,
                a_qr_code: '',
                dialog_errores: false,
                errores_guard: '',
                head_color: '',
                band_gafete: false,
                dialogIP: false,
                ip: '127.0.0.1',
                loading: false,
                loadingCount: false,
                devices: [],
                cams: [],
                qrs: [],
                loadingCountIn: false,
                loading_data_accesos_without_code: false,
                headers4: [],
                fecha_actual: '',
                yyyy: '',
                mm: '',
                dd: '',
                yyyy2: '',
                mm2: '',
                dd2: '',
                accesos_without_code: [],

            }
        },
        created: function(){
            this.fecha_actual = this.get_current_date()
            this.get_access_employee(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            this.get_casetas()
            if(localStorage.getItem('id_caseta') === null){
                this.dialog_inicio = true
            }
            if(localStorage.getItem('dirIP') === null){
                this.ip = "127.0.0.1"
            } else {
                this.ip = localStorage.getItem('dirIP')
            }
        },
        beforeUpdate() {
            this.headers4 = [
                // {
                //     text: this.$t('detalle'),
                //     align: 'center',
                //     sortable: false,
                //     value: 'details'
                // },
                {
                    text: this.$t('nombre'),
                    align: 'center',
                    sortable: true,
                    value: 'full_name'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'center',
                    sortable: true,
                    value: 'f_acceso'
                },
                {
                    text: this.$t('caseta_in'),
                    align: 'center',
                    sortable: true,
                    value: 'id_caseta_in'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'center',
                    sortable: true,
                    value: 'f_salida'
                },
                {
                    text: this.$t('caseta_out'),
                    align: 'center',
                    sortable: true,
                    value: 'id_caseta_out'
                },
            ]
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['caseta_vigilante'])
        },
        methods: {
            get_access_employee: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos_without_code = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresa/get_acceso/rfid/' + yyyy + '/'  + mm + '/' + dd + '/'+ yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.status === 204)
                            this.accesos_without_code = []
                        else
                            this.accesos_without_code = response.data
                        this.loading_data_accesos_without_code = false
                    })
                    .catch(error => {
                        this.loading_data_accesos_without_code = false
                        console.log(error)
                    })

            },
            get_current_date () {
                var today = new Date();
                this.dd = today.getDate();
                this.mm = today.getMonth()+1;
                this.yyyy = today.getFullYear();
                this.dd2 = today.getDate();
                this.mm2 = today.getMonth()+1;
                this.yyyy2 = today.getFullYear();

                if(this.dd<10)
                {
                    this.dd='0'+this.dd;
                }
                if(this.dd2<10)
                {
                    this.dd2='0'+this.dd2;
                }

                if(this.mm<10)
                {
                    this.mm='0'+this.mm;
                }
                if(this.mm2<10)
                {
                    this.mm2='0'+this.mm2;
                }

                today = this.yyyy + '-' + this.mm + '-' + this.dd;
                return today
            },
            changeDirIP () {
                localStorage.setItem('dirIP', this.ip)
            },
            get_casetas: function(){
                this.$store.dispatch('security/FETCH_MY_CASETAS', store.getters.getToken)
                    .then(response => {
                        // Manejar múltiples formatos de respuesta
                        if (response && response.casetas && Array.isArray(response.casetas)) {
                            this.casetas = response.casetas
                        } else if (Array.isArray(response)) {
                            this.casetas = response
                        } else if (response && response.data && Array.isArray(response.data)) {
                            this.casetas = response.data
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            getDevicesByGuardHouse () {
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/Devices/guardhouse/' + localStorage.getItem('id_caseta') + '/devices/',
                headers: {
                  'Content-Type': 'application/json',
                  'authorization': 'Token ' + store.getters.getToken
                }
              }
              axios(config)
                .then(response => {
                  this.devices = response.data
                  for (let i = 0; i < this.devices.length; i++) {
                    if (this.devices[i].classification === 'qr') {
                      this.qrs.push(this.devices[i])
                    }
                    if (this.devices[i].classification === 'cam') {
                      this.cams.push(this.devices[i])
                    }
                  }
                  localStorage.setItem('qr_devices', JSON.stringify(this.qrs))
                  this.$store.commit('setQRDevices', JSON.parse(localStorage.getItem('qr_devices')))
                  localStorage.setItem('cam_devices', JSON.stringify(this.cams))
                  this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
                  // if (this.qrs.length > 0) {
                  //   this.$store.commit('enableBandQr', true)
                  //   localStorage.setItem('banderaQR', true)
                  // } else {
                  //   this.$store.commit('enableBandQr', false)
                  //   localStorage.setItem('banderaQR', false)
                  // }
                  // if (this.cams.length > 0) {
                  //   localStorage.setItem('banderaCam', true)
                  //   this.$store.commit('enableBandCam', true)
                  // } else {
                  //   localStorage.setItem('banderaCam', false)
                  //   this.$store.commit('enableBandCam', false)
                  // }
                  // Iniciar Sesión en Socket
                  // this.connectToWebSocket()
                })
                .catch(error => {
                  console.log(error)
                })
            },
            set_caseta: function(){
                if(this.caseta > 0){
                    localStorage.setItem('id_caseta', this.caseta)
                    // Obtenemos Dispositivos de la Caseta
                    this.getDevicesByGuardHouse()
                    this.dialog_inicio = false
                }
            },
            onDecode (result) {
                this.qr_code = result
                this.get_invitation()
            },
            get_invitation: function(){
                if (this.qr_code !== '') {
                    this.loading = true
                    const config = {
                        method: 'post',
                        url: 'https://empresa-service.intrare.app/empresa/acceso/rfid/guard/' + this.qr_code + '/',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: {
                          // uuid_device: JSON.parse(localStorage.getItem('qr_devices'))[0].uuid,
                          id_company: this.getProfile.id_company,
                          id_caseta: localStorage.getItem('id_caseta')
                        }
                    };
                    axios(config)
                        .then(response => {
                            console.log(response.status)
                            switch (response.status) {
                              case 201:
                                this.loading = false
                                this.valido = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
                                setTimeout(this.clear, 3000)
                              break;
                              case 204:
                                this.loading = false
                                this.valido = false
                                console.log("NO Valido")
                                this.clear_without_activate_camera()
                                this.errores_guard =this.$t('mensaje_qr_no_valido')
                                this.head_color = 'red display-1 text--primary'
                                this.dialog_errores = true
                              break;
                            }
                        })
                        .catch(error => {
                            this.loading = false
                            // console.log(error)
                            switch (error.request.status) {
                              case 401:
                                // console.log(error.request.response)
                                this.info_invitation = JSON.parse(error.request.response)
                                console.log(this.info_invitation.fullname)
                                // console.log(JSON.parse(this.info_invitation))
                                // console.log(this.info_invitation.id_usuario)
                                console.log("Entrada de Empleado")
                                this.empleado = true
                                this.entrada = false
                                this.salida = false
                                // this.dialog = true
                                this.activar_camara = false
                              break;
                            }
                        })
                }
            },
            get_invitation_manual: function(){
                this.loading = true
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/empresa/acceso/rfid/guard/' + this.a_qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                      // uuid_device: JSON.parse(localStorage.getItem('qr_devices'))[0].uuid,
                      id_company: this.getProfile.id_company,
                      id_caseta: localStorage.getItem('id_caseta')
                    }
                };
                axios(config)
                    .then(response => {
                        console.log(response.status)
                        switch (response.status) {
                          case 201:
                            this.loading = false
                            this.valido = false
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
                            setTimeout(this.clear, 3000)
                          break;
                          case 204:
                            this.loading = false
                            this.valido = false
                            console.log("NO Valido")
                            this.clear_without_activate_camera()
                            this.errores_guard =this.$t('mensaje_qr_no_valido')
                            this.head_color = 'red display-1 text--primary'
                            // this.dialog_errores = true
                          break;
                        }
                        // this.info_invitation = response.data
                        // this.qr_is_valid(this.info_invitation)
                    })
                    .catch(error => {
                        this.loading = false
                        switch (error.request.status) {
                          case 401:
                            // console.log(error.request.response)
                            this.info_invitation = JSON.parse(error.request.response)
                            console.log(this.info_invitation.fullname)
                            // console.log(JSON.parse(this.info_invitation))
                            // console.log(this.info_invitation.id_usuario)
                            console.log("Entrada de Empleado")
                            this.empleado = true
                            this.entrada = false
                            this.salida = false
                            // this.dialog = true
                            this.activar_camara = false
                            this.create_acceso(this.info_invitation.rfid)
                          break;
                        }
                    })

            },
            qr_is_valid: function(info_invitation){
                console.log(Object.keys(info_invitation).length)
                if (Object.keys(info_invitation).length > 0) {
                    this.valido = true
                    console.log("Valido")
                    this.is_access_in_out_both()
                }
                else{
                    this.valido = false
                    console.log("NO Valido")
                    //     this.$store.commit('snackbar_activate_true')
                    //     this.$store.commit('snackbar_change_color', 'error')
                    //     this.$store.commit('snackbar_change_message', this.$t('mensaje_qr_no_valido'))
                    //     setTimeout(this.clear, 3000)
                    this.clear_without_activate_camera()
                    this.errores_guard =this.$t('mensaje_qr_no_valido')
                    this.head_color = 'red display-1 text--primary'
                    this.dialog_errores = true
                }
            },
            is_access_in_out_both: function(){
                if(this.a_qr_code.length > 10)
                    this.qr_code = this.a_qr_code
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        console.log(response.data)
                        this.data_access = response.data
                          if (this.info_invitation.typeInv !== 2) { // Tipo de Invitación Normal
                            if (response.data.length > 0 && response.data[0].fecha_hora_acceso != null && response.data[0].fecha_hora_salida != null){
                              // alert('Ya se completó el acceso con la invitación Correspondiente.')
                              console.log('COMPLETO')
                              this.clear_without_activate_camera()
                              this.head_color = 'orange display-1 text--primary'
                              this.errores_guard =this.$t('mensaje_acceso_completo')
                              this.dialog_errores = true

                            }
                            else{
                              if(response.data.length > 0 ){
                                this.entrada = false
                                this.salida = true
                                this.dialog = true
                                this.activar_camara = false
                                console.log('SALIDA')
                              }
                              else{
                                this.entrada = true
                                this.salida = false
                                this.dialog = true
                                this.activar_camara = false
                                console.log('ENTRADA')
                              }
                            }
                          } else { // Invitación Recurrente
                            if (response.data.length === 0) {
                              this.entrada = true
                              this.salida = false
                              this.dialog = true
                              this.activar_camara = false
                              console.log('ENTRADA RECURRENTE')
                            } else {
                              if (response.data[0].estado === 1) {
                                this.entrada = false
                                this.salida = true
                                this.dialog = true
                                this.activar_camara = false
                                console.log('SALIDA RECURRENTE', response.data[0])
                              } else {
                                var fechaLocal = new Date(this.get_current_date())
                                const readableDate = response.data[0].fecha_hora_acceso.substring(3, 6) + response.data[0].fecha_hora_acceso.substring(0, 2) + response.data[0].fecha_hora_acceso.substring(5, 10)
                                var fechaAccesoEntrada = new Date(readableDate)
                                if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                                  this.entrada = true
                                  this.salida = false
                                  this.dialog = true
                                  this.activar_camara = false
                                  console.log('ENTRADA RECURRENTE')
                                } else {
                                  console.log('COMPLETO RECURRENTE')
                                  this.clear_without_activate_camera()
                                  this.head_color = 'orange display-1 text--primary'
                                  this.errores_guard = this.$t('mensaje_acceso_completo')
                                  this.dialog_errores = true
                                }
                              }
                            }
                          }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            create_acceso: function(rfid){
                this.loading = true
                console.log(this.qr_code)
                var qrCode = this.qr_code
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/empresa/acceso/rfid/' + rfid + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        id_caseta: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        // this.$store.commit('snackbar_activate_true')
                        // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
                        this.get_access_employee(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        this.clear()
                        // setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.clear_without_activate_camera()
                        this.head_color = 'red display-1 text--primary'
                        this.errores_guard = error.response.data.error
                        // this.dialog_errores = true
                    })
            },
            sendDataWebServer (qrCode) {
                const config = {
                    method: 'post',
                    url: 'http://' + localStorage.getItem('dirIP') + '/set_data',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {
                        qr_code: qrCode,
                        area: this.info_invitation.areaName
                    }
                }
                axios(config)
                    .then(response => {
                        console.log('Datos enviados al Web Server Correctamente.')
                        console.log(response)
                    })
                    .catch(error => {
                        console.log('Error del Web Server.')
                        console.log(error.response.data)
                    })
            },
            update_acceso (pk){
                this.loading = true
                console.log(this.qr_code)
                const config = {
                    method: 'put',
                    url: 'https://empresa-service.intrare.app/empresas/access/update/forExit/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        estado: 0,
                        motivo_no_firma: this.motivo_no_firma,
                        comentarios_VE: this.comentarios_VE,
                        id_guardhouse_checkout: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.clear_without_activate_camera()
                        this.head_color = 'green display-1 text--primary'
                        this.errores_guard =this.$t('mensaje_alta_acceso_out')
                        this.dialog_errores = true
                        // this.$store.commit('snackbar_activate_true')
                        // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_out'))
                        // setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        this.loading = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })

            },
            updateCount () {
                this.loadingCount = true
                const config2 = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config2)
                    .then(response2 => {
                        if (this.info_invitation.typeInv !== 2)
                            this.data_access = response2.data
                        else
                          if (response2.data.length > 1) {
                            this.data_access = response2.data
                            console.log('Datos Accesos Count = ', response2.data[0])
                            }
                          else
                            this.data_access = response2.data
                        this.loadingCount = false
                    })
                    .catch(error => {
                        this.loadingCount = false
                        console.log(error)
                    })
            },
            updateCountEntrada () {
                this.loadingCountIn = true
                const config2 = {
                    method: 'get',
                    url:  'https://empresa-service.intrare.app/get_inv/gaurd/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config2)
                    .then(response2 => {
                        if (this.info_invitation.typeInv !== 2)
                            this.info_invitation = response2.data
                        else
                          if (response2.data.length > 1) {
                            this.info_invitation = response2.data
                            console.log('Datos Invitacion Count = ', response2.data[0])
                            }
                          else
                            this.info_invitation = response2.data
                        this.loadingCountIn = false
                    })
                    .catch(error => {
                        this.loadingCountIn = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_firmar(){
                this.loading = true
                console.log('Avisar al Anfitrión que firme pase de Salida = ', this.data_access[0].id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifySignExitPass/' + this.data_access[0].id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        const config2 = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        }
                        axios(config2)
                            .then(response2 => {
                                console.log(response2.data)
                                if (this.info_invitation.typeInv !== 2)
                                    this.data_access = response2.data
                                else
                                  if (response2.data.length > 1) {
                                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                                    this.data_access = response2.data
                                  }
                                  else
                                    this.data_access = response2.data
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_acceso(){
                this.loading = true
                console.log('Avisar al Anfitrión que autorize el acceso de su invitado= ', this.info_invitation.id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifyAuthorizedAccess/' + this.info_invitation.id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        const config2 = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/get_inv/gaurd/' + this.qr_code + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        }
                        axios(config2)
                            .then(response2 => {
                                console.log(response2.data)
                                if (this.info_invitation.typeInv !== 2)
                                    this.info_invitation = response2.data
                                else
                                  if (response2.data.length > 1) {
                                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                                    this.info_invitation = response2.data
                                  }
                                  else
                                    this.info_invitation = response2.data
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            async onInit (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.error = "ERROR: you need to grant camera access permisson"
                    } else if (error.name === 'NotFoundError') {
                        this.error = "ERROR: no camera on this device"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "ERROR: secure context required (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "ERROR: is the camera already in use?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "ERROR: installed cameras are not suitable"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "ERROR: Stream API is not supported in this browser"
                    }
                }
            },
            clear: function () {
                this.dialog = false
                this.qr_code = ''
                this.a_qr_code = ''
                this.entrada = false
                this.salida = false
                this.activar_camara = true
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
            },
            clear_without_activate_camera: function () {
                this.dialog = false
                this.activar_camara = false
                this.qr_code = ''
                this.a_qr_code = ''
                this.entrada = false
                this.salida = false
            },
            get_equipo_invitacion: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/equipo_seguridad/' + this.info_invitation.id + '/',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                axios(config)
                    .then(response => {
                        this.equipo_por_invitacion = response.data
                        console.log(this.equipo_por_invitacion)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            xOffset: function(pdf, text){
                return ((pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2) / 72.0)
            },
            getImgFromUrl(logo_url, callback) {
                var img = new Image();
                img.src = logo_url;
                img.onload = function () {
                    callback(img);
                };
            },
            download_gafete_original: function(){
                this.loading_gafete = true
                console.log('Datos de la Invitación: ')
                console.log(this.info_invitation)
                // console.log(this.info_invitation)
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };

                toDataUrl(this.info_invitation.avatar, (myBase64) => {
                    var pdf = new jsPDF("portrait", "pt", "letter")
                    // Black square with rounded corners
                    pdf.setDrawColor(0)
                    pdf.setFillColor(255, 255, 255)
                    pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.empresa,
                        this.xOffset(pdf, this.info_invitation.empresa),
                        130)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Visitante'),
                        this.xOffset(pdf, this.$t('Visitante')),
                        145)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName,
                        this.xOffset(pdf, this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName) ,
                        160)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Anfitrion'),
                        this.xOffset(pdf, this.$t('Anfitrion')),
                        175)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName,
                        this.xOffset(pdf, this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName),
                        190)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Area'),
                        this.xOffset(pdf, this.$t('Area')),
                        205)
                    pdf.setTextColor(this.info_invitation.areaColor)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.areaName.toUpperCase(),
                        this.xOffset(pdf, this.info_invitation.areaName.toUpperCase()),
                        220)
                    pdf.setTextColor('#000000')
                    pdf.text(this.$t('fecha_hora'),
                        this.xOffset(pdf, this.$t('fecha_hora')),
                        235)
                    pdf.setFontStyle("normal")
                    pdf.text(this.info_invitation.dateInv + ' ' + this.info_invitation.timeInv,
                        this.xOffset(pdf, this.info_invitation.dateInv + ' ' +  this.info_invitation.timeInv),
                        250)
                    pdf.setLineWidth(4.0)
                    pdf.setDrawColor(this.info_invitation.areaColor)
                    pdf.setFillColor('#FFFFFF')
                    pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
                    // console.log(myBase64); // myBase64 is the base64 string
                    pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
                    toDataUrl(this.info_invitation.logoEmpresa, (logo_guest) => {
                        pdf.addImage(logo_guest, 'WEBP', 190, 60, 50, 50);
                        this.getImgFromUrl(require('../../assets/intrare_logo.png'), function (logo_system,) {
                            pdf.addImage(logo_system, 'WEBP', 370, 60, 50, 50);
                            pdf.save('gafete.pdf')
                        });
                    });
                    this.loading_gafete = false
                });
            },
            download_gafete: function(){
                this.loading_gafete = true
                console.log('Datos de la Invitación: ')
                console.log(this.info_invitation)
                // console.log(this.info_invitation)
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };
                var pdf = new jsPDF('l', 'in', [288, 144])
                // Black square with rounded corners
                pdf.setDrawColor(0)
                pdf.setFontSize(9)
                pdf.text(this.$t('fecha_hora_acceso'),
                    2,
                    0.4)
                pdf.setLineWidth(0.02)
                pdf.line(2, 0.42, 3.4, 0.42)
                pdf.setFontStyle("normal")
                pdf.text(this.info_invitation.dateInv + ' ' + this.info_invitation.timeInv,
                    2.25,
                    0.6)
                pdf.setFontSize(14)
                // pdf.setFillColor(255, 255, 255)
                // pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
                // pdf.setFontStyle("bold")
                // pdf.text(this.info_invitation.empresa,
                //     this.xOffset(pdf, this.info_invitation.empresa),
                //     130)
                pdf.line(this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 0.92, 2.5, 0.92)
                pdf.setFontStyle("normal")
                pdf.text(this.$t('Visitante').toUpperCase(),
                    this.xOffset(pdf, this.$t('Visitante').toUpperCase()),
                    0.9)
                pdf.setFontStyle("bold")
                pdf.text(this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName,
                    this.xOffset(pdf, this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName),
                    1.2)
                pdf.line(this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 1.47, 2.5, 1.47)
                pdf.setFontStyle("normal")
                pdf.text(this.$t('Anfitrion').toUpperCase(),
                    this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()),
                    1.45)
                pdf.setFontStyle("bold")
                pdf.text(this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName,
                    this.xOffset(pdf, this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName),
                    1.70)
                // pdf.setFontStyle("normal")
                // pdf.text(this.$t('Area'),
                //     this.xOffset(pdf, this.$t('Area')),
                //     205)
                // pdf.setTextColor(this.info_invitation.areaColor)
                // pdf.setFontStyle("bold")
                // pdf.text(this.info_invitation.areaName.toUpperCase(),
                //     this.xOffset(pdf, this.info_invitation.areaName.toUpperCase()),
                //     220)
                pdf.setTextColor('#000000')
                // pdf.setLineWidth(4.0)
                // pdf.setDrawColor(this.info_invitation.areaColor)
                // pdf.setFillColor('#FFFFFF')
                // pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
                // console.log(myBase64); // myBase64 is the base64 string
                // pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
                toDataUrl(this.info_invitation.logoEmpresa, (logo_guest) => {
                    pdf.addImage(logo_guest, 'WEBP', 0.25, 0.25, 0.8, 0.6);
                    pdf.save('gafete.pdf')
                    this.loading_gafete = false
                });
            }
        }
    }
</script>

<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }

    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #002b48;
        color: white;
    }
</style>
